import React from 'react';

const getDateState = (date, records) => {
    let total = 0;
    let empty = 0;

    records.forEach(record => {
        if (!!record.receptions[date]) {
            total = total + record.receptions[date].total;
            empty = empty + record.receptions[date].empty;
        }
    });

    return {
        total: total,
        empty: empty
    }
};

export default (props) => {
    return (
        <tr>
            {props.dates.map(date => {
                if (date !== 'Врач') {
                    let state = getDateState(date, props.records);

                    return (
                        <td
                            align="center"
                            bgcolor={props.setColor(state.empty / state.total)}
                            style={{width: 260, position: 'sticky', top: 33}}
                        >
                            {state.empty + '/' + state.total}
                        </td>
                    )
                }
            })}
        </tr>
    )
}